const SchedularFrom = () => import("./views/SchedulerForm.vue");
export default [
  {
    path: "create",
    component: SchedularFrom,
  },
];
